import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToSecureYourSeedRound() {
  return <section data-section-id="185233" id="take-the-first-step" className="dark bg-primary text-primary-foreground relative overflow-hidden py-32 md:py-48 flex items-center justify-center min-h-[60vh] border-y border-border/10">
      {}
      <style>{`
        @keyframes radar-ripple {
          0% { 
            transform: scale(0.1); 
            opacity: 0.8; 
            border-width: 2px; 
          }
          100% { 
            transform: scale(3.5); 
            opacity: 0; 
            border-width: 1px; 
          }
        }
      `}</style>

      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_70%)] opacity-20" />
      <div className="absolute inset-0 bg-primary/40 backdrop-blur-[2px]" />

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        {[0, 1, 2, 3].map(i => <div key={i} data-index={i} className="absolute size-[400px] rounded-full border border-secondary/50" style={{
        animation: 'radar-ripple 8s cubic-bezier(0.1, 0.7, 0.1, 1) infinite',
        animationDelay: `${i * 2}s`
      }} />)}
        {}
        <div className="absolute size-32 rounded-full bg-secondary/30 blur-3xl animate-pulse" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold tracking-tighter text-primary-foreground mb-10 drop-shadow-2xl">
          Ready to break free? <br className="hidden md:block" /> It starts with a simple conversation.
        </h2>
        
        <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 text-lg md:text-xl h-14 md:h-16 px-8 md:px-12 rounded-full font-default font-semibold shadow-[0_0_50px_-12px_rgba(255,255,255,0.4)] transition-all duration-300 hover:scale-105 hover:shadow-[0_0_60px_-10px_rgba(255,255,255,0.6)] border-0">
          <Link to="https://quitmytimeshare.com/eligibility-check/">
            Check Eligibility
          </Link>
        </Button>
      </div>
    </section>;
}